export default __webpack_public_path__ + "static/media/1(6).b93a35b5.jpg";